import type { SelectHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from './utils';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
    error?: boolean;
    /** Estilo compacto para FilterBar */
    filter?: boolean;
};

const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ className, error, filter = false, children, ...props }, ref) => {
        return (
            <select
                ref={ref}
                className={cn(
                    'nx-select',
                    filter && 'nx-select--filter',
                    error && 'nx-select--error',
                    className,
                )}
                aria-invalid={error || props['aria-invalid'] ? true : undefined}
                {...props}
            >
                {children}
            </select>
        );
    },
);

Select.displayName = 'Select';

export { Select };
export type { SelectProps };
